import {useState} from "react";
import {useRecordEvent} from "aws-rum-react";
import {IExtractImageModel} from "../types/manualFinder";
import {queryItemFromPinecone} from "../services/imageMatcher/queryItemFromPinecone";
import {selectedImageMatcherURL} from "../utils/imageMatcherUtil";
import {useUploadedImages} from "./useUploadedImages";

export const useImageActions = (
    parentImages: IExtractImageModel[],
    setParentImages: (parentImages: IExtractImageModel[]) => void
) => {
  const recordEvent = useRecordEvent();
  const [reloadTaImages, setReloadTaImages] = useState(
      parentImages.map(() => false)
  );
  const {handleSetUploadedImages} = useUploadedImages();

  const onRefresh = async (index: number) => {
    setReloadTaImages((prev) => {
      const updated = [...prev];
      updated[index] = true;
      return updated;
    });

    const pineconeQueryResult = await queryItemFromPinecone({
      dropFileId: parentImages[index].parentFile.id ?? "",
      key: parentImages[index].parentFile.fileobject?.name as string,
      topK: 3,
    });

    setReloadTaImages((prev) => {
      const updated = [...prev];
      updated[index] = false;
      return updated;
    });
    const currentParentImages = [...parentImages];
    currentParentImages[index].matches = pineconeQueryResult.results;
    parentImages[index].parentFile.pineconeResult = pineconeQueryResult;
    recordEvent(pineconeQueryResult.trackingModel, {
      duration: `${(pineconeQueryResult.duration / 1000).toFixed(2)}s`,
    });
    setParentImages(currentParentImages);
  };

  const createDropFileObject = async (index: number) => {
    const dropFile = parentImages[index].parentFile;
    handleSetUploadedImages([dropFile]);
    window.open(selectedImageMatcherURL(dropFile.id), "_blank");
  };

  return {onRefresh, createDropFileObject, reloadTaImages};
};
